// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"3p0gh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Function to get today's workout, no input required
parcelHelpers.export(exports, "getTodaysWorkout", ()=>getTodaysWorkout);
parcelHelpers.export(exports, "doubleTodaysWorkout", ()=>doubleTodaysWorkout);
const exercises = [
    {
        name: "Torso Twists",
        targetArea: "abs",
        difficulty: "beginner",
        linkValue: "torso twists exercise"
    },
    {
        name: "Plank Jacks",
        targetArea: "cardio",
        difficulty: "intermediate",
        linkValue: "plank jack alternatives"
    },
    {
        name: "Jump Squats",
        targetArea: "legs",
        difficulty: "intermediate",
        linkValue: "jump squat alternatives"
    },
    {
        name: "Burpees",
        targetArea: "full body",
        difficulty: "advanced",
        linkValue: "burpee alternatives"
    },
    {
        name: "Russian Twists",
        targetArea: "abs",
        difficulty: "intermediate",
        linkValue: "russian twists exercise"
    },
    {
        name: "Plank",
        targetArea: "abs",
        difficulty: "beginner",
        linkValue: "plank alternatives"
    },
    {
        name: "Leg Raises",
        targetArea: "abs",
        difficulty: "beginner",
        linkValue: "leg raise exercise"
    },
    {
        name: "Bicycle Crunches",
        targetArea: "abs",
        difficulty: "intermediate",
        linkValue: "bicycle crunch exercise"
    },
    {
        name: "Calf Raises",
        targetArea: "legs",
        difficulty: "beginner",
        linkValue: "calf raise exercise"
    },
    {
        name: "Side Lunges",
        targetArea: "legs",
        difficulty: "intermediate",
        linkValue: "side lunges exercise"
    },
    {
        name: "Glute Bridges",
        targetArea: "legs",
        difficulty: "beginner",
        linkValue: "glute bridge exercise"
    },
    {
        name: "Lunges",
        targetArea: "legs",
        difficulty: "beginner",
        linkValue: "lunge exercise"
    },
    {
        name: "Squats",
        targetArea: "legs",
        difficulty: "beginner",
        linkValue: "squat alternatives"
    },
    {
        name: "Tricep Dips",
        targetArea: "arms",
        difficulty: "intermediate",
        linkValue: "tricep dip alternatives"
    },
    {
        name: "Shoulder Taps",
        targetArea: "arms",
        difficulty: "beginner",
        linkValue: "shoulder tap exercise"
    },
    {
        name: "Push-ups",
        targetArea: "arms",
        difficulty: "intermediate",
        linkValue: "pushup alternatives"
    },
    {
        name: "Mountain Climbers",
        targetArea: "cardio",
        difficulty: "intermediate",
        linkValue: "mountain climber alternatives"
    },
    {
        name: "High Knees",
        targetArea: "cardio",
        difficulty: "beginner",
        linkValue: "high knees exercise"
    },
    {
        name: "Jumping Jacks",
        targetArea: "cardio",
        difficulty: "beginner",
        linkValue: "jumping jacks exercise"
    },
    {
        name: "Superman Raises",
        targetArea: "full body",
        difficulty: "beginner",
        linkValue: "superman raises exercise"
    },
    {
        name: "Inchworms",
        targetArea: "full body",
        difficulty: "intermediate",
        linkValue: "inchworm exercise"
    },
    {
        name: "Plank with Arm Lift",
        targetArea: "abs",
        difficulty: "intermediate",
        linkValue: "plank with arm lift"
    },
    {
        name: "Small Arm Circles",
        targetArea: "arms",
        difficulty: "beginner",
        linkValue: "small arm circles exercise"
    },
    {
        name: "Wall Sit",
        targetArea: "legs",
        difficulty: "beginner",
        linkValue: "wall sit exercise"
    },
    {
        name: "Toe Touches",
        targetArea: "abs",
        difficulty: "beginner",
        linkValue: "toe touch exercise"
    },
    {
        name: "Flutter Kicks",
        targetArea: "abs",
        difficulty: "intermediate",
        linkValue: "flutter kicks exercise"
    }
];
let todaysWorkout = generateTodaysWorkout();
// Function to group exercises by target area
function groupByTargetArea(exercises) {
    return exercises.reduce((groups, exercise)=>{
        const { targetArea } = exercise;
        if (!groups[targetArea]) groups[targetArea] = [];
        groups[targetArea].push(exercise);
        return groups;
    }, {});
}
// Function to get a consistent random number generator based on the date and offset
function seededRandom(seed, offset = 0) {
    const x = Math.sin(seed + offset) * 10000;
    return x - Math.floor(x);
}
function generateTodaysWorkout() {
    const groupedExercises = groupByTargetArea(exercises);
    const targetAreas = Object.keys(groupedExercises);
    const today = new Date();
    const seed = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate(); // Unique seed based on date
    const workout = targetAreas.map((targetArea, index)=>{
        const exercisesForArea = groupedExercises[targetArea];
        const randomIndex = Math.floor(seededRandom(seed, index) * exercisesForArea.length);
        return exercisesForArea[randomIndex];
    });
    return workout;
}
function getTodaysWorkout() {
    return todaysWorkout;
}
function doubleTodaysWorkout() {
    todaysWorkout = [
        ...todaysWorkout,
        ...todaysWorkout
    ]; // Concatenates the array with itself
    console.log("Workout list doubled:", todaysWorkout);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},["3p0gh"], "3p0gh", "parcelRequire3809")

//# sourceMappingURL=index.933b055b.js.map
